import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=de8daca0&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=de8daca0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8daca0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('de8daca0')) {
      api.createRecord('de8daca0', component.options)
    } else {
      api.reload('de8daca0', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=de8daca0&scoped=true&", function () {
      api.rerender('de8daca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HvNspqQzkd0f/JS/comp/CookieBox.vue"
export default component.exports